/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { createPortal } from 'react-dom'

import { transparentize } from 'polished'
import styled from 'styled-components'

import FlexBox from 'src/components/Common/FlexBox'

import { useModalV2Context } from './modal-v2.hooks'
import DismissableDialog from './ui/DismissableDialog'

const portalRoot = document.getElementById('modal-v2-root') || document.body

const ModalV2 = () => {
  const { modalsStack } = useModalV2Context()

  return createPortal(
    <StyledModal>
      <StyledDimmer alignItems="center" justifyContent="center" />

      {Array.from(modalsStack).map(([key, { content, ...modalConfig }]) => (
        <DismissableDialog children={content} {...modalConfig} key={key} />
      ))}
    </StyledModal>,
    portalRoot
  )
}

export default ModalV2

const StyledModal = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1001;
`

const StyledDimmer = styled(FlexBox)`
  background-color: ${({ theme }) => transparentize(0.33, theme.colors.baseBlack)};
  width: 100vw;
  height: 100vh;
`
